import ErrorBoundary from "@/components/shared/ErrorBoundary";
import BilagTab from "@/components/project/BilagTab";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";

export default function BilagPage() {
  const { project, vouchers, budgetLines, voucherAllocations } =
    useProjectDetailContext();
  return (
    <ErrorBoundary>
      <div className="space-y-4">
        <BilagTab
          projectId={project.id}
          vouchers={vouchers}
          budgetLines={budgetLines}
          voucherAllocations={voucherAllocations}
        />
      </div>
    </ErrorBoundary>
  );
}
